import { isAuthenticated, hasAccess } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'residential-templates',
    path: '/residential-templates',
    component: () =>
      LazyLoadView(
        import(/* webpackChunkName: "residential-templates" */ '@/views/ResidentialTemplate/ResidentialTemplates.vue'),
      ),
    beforeEnter: hasAccess('residentialTemplates'),
  },
  {
    name: 'residential-template-create',
    path: '/residential-templates/create/:step?',
    component: () =>
      LazyLoadView(
        import(
          /* webpackChunkName: "residential-template-mutate" */ '@/views/ResidentialTemplate/Mutate/Component.vue'
        ),
      ),
    props: true,
    beforeEnter: hasAccess('residentialTemplates'),
  },
  {
    name: 'residential-template-edit',
    path: '/residentials-template/:id/edit/:step?',
    props: true,
    component: () =>
      LazyLoadView(
        import(
          /* webpackChunkName: "residential-template-mutate" */ '@/views/ResidentialTemplate/Mutate/Component.vue'
        ),
      ),
    beforeEnter: hasAccess('residentialTemplates'),
  },
]
